import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import html2pdf from "html2pdf.js";
import { Container, Typography } from "@mui/material";
import { vehicleCodeChanger } from "../helpers/vehicleCodeChanger";
import emailBanner from "../Assets/emailBanner.png";
import emailSignature from "../Assets/emailSignature.png";
const Confirmation = ({
  vehicleChoosedDetails,
  reservationDetails,
  checkInData,
  clientDetails,
  vehicleExtras,
  totalRentalValue,
  pickUpDesk,
  dropOffDesk,
  totalDays,
  paymentType,
  fullTotalValue,
}) => {
  const { t } = useTranslation();
  const hasRun = useRef(false); // Initialize ref to track execution
  const missingPayment =
    fullTotalValue?.toFixed(2) - totalRentalValue?.toFixed(2);

  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    if (hasRun.current) return; // Skip if the effect has already run

    hasRun.current = true; // Mark as executed

    const element = document.querySelector("#confirmation");
    var opt = {
      margin: 20,
      filename: "whyNotCarRentalBookingConfirmation.pdf",
    };

    if (mapLoaded) {
      html2pdf(element, opt);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapLoaded]);

  useEffect(() => {
    let emailExtras = "";

    vehicleExtras
      ?.filter((fee) => fee.quantity > 0)
      ?.map(
        (fee) =>
          (emailExtras += `\n${
            fee.extraName === "fullInsurance"
              ? t("fullInsurance")
              : fee.extraName === "babySeat"
              ? t("babySeat")
              : fee.extraName === "babySeatIsofix"
              ? t("babySeatIsofix")
              : fee.extraName === "boosterSeat"
              ? t("boosterSeat")
              : fee.extraName === "additionalDriver"
              ? t("additionalDriver")
              : fee.extraName === "youngDriver"
              ? t("youngDriver")
              : fee.extraName === "airportDeliveryExtra"
              ? t("airportDeliveryExtra")
              : fee.extraName === "outOfFunchalDelivery"
              ? t("outOfFunchalDelivery")
              : null
          } -> ${fee.totalValue}€ \n`)
      );

    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="confirmation">
      <>
        <img
          src={emailBanner}
          alt="WhyNot Car Rental Logo"
          style={{ width: "100%", maxHeight: "300px", display: "block" }}
        />
        <Typography variant="h4">{t("bookingConfirmed")}</Typography>
        <Typography variant="h5">{t("bookingSummary")}</Typography>
        <Typography variant="body1">
          <b>{t("orderId")}</b>: {checkInData.idreserva}
        </Typography>
        <Typography variant="body1">
          {t("pickUp")}:{" "}
          {pickUpDesk === 41
            ? "Funchal- Rua Ivens Nº12"
            : pickUpDesk === 42
            ? "Aeroporto da Madeira"
            : pickUpDesk === 47
            ? " Calheta"
            : pickUpDesk === 46
            ? " Norte"
            : "Unknown Location"}
        </Typography>
        <Typography>
          {t("deliveryDate")}: {reservationDetails.date_pickup}
        </Typography>
        <Typography>
          {t("deliveryTime")}: {reservationDetails.time_pickup}
        </Typography>
        <Typography>
          {t("dropOff")}:{" "}
          {dropOffDesk === 41
            ? " Funchal- Rua Ivens Nº12"
            : dropOffDesk === 42
            ? " Aeroporto da Madeira"
            : dropOffDesk === 47
            ? " Calheta"
            : dropOffDesk === 46
            ? " Norte"
            : "Unknown Location"}
        </Typography>
        <Typography>
          {t("returnDate")}: {reservationDetails.date_return}
        </Typography>
        <Typography>
          {t("returnTime")}: {reservationDetails.time_return}
        </Typography>
        <Typography variant="body1">
          <b>{t("clientDetails")}:</b>
        </Typography>
        <Typography>
          {t("fullName")}: {clientDetails.customer_name}
        </Typography>
        <Typography>
          {t("email")}: {clientDetails.customer_email}
        </Typography>
        <Typography>
          {t("phone")}: {clientDetails.countryCode}-
          {clientDetails.customer_telephone}
        </Typography>
        <Typography>{t("vehicleChoosed")}:</Typography>
        <Typography>
          {t("model")}: {vehicleChoosedDetails.vehicleModel} {t("orSimilar")}
        </Typography>
        <Typography>
          {t("group")}: {vehicleCodeChanger(vehicleChoosedDetails.vehicleCode)}
        </Typography>
        {paymentType === "partial" ? (
          <Typography>
            <b>{t("partialValuePaid")}</b>
            <br />
            <b>{t("payed")}: </b>
            {totalRentalValue.toFixed(2)}
            <br />
            <b>{t("totalRentalValueIs")}: </b>
            {fullTotalValue.toFixed(2)}
            <br />
          </Typography>
        ) : (
          <Typography>
            <b>{t("totalValuePaid")} </b>
            <br />
            <b>{t("payed")}: </b>
            {totalRentalValue.toFixed(2)}€
          </Typography>
        )}
        <Typography>{t("extrasChoosed")}:</Typography>
        {vehicleExtras.length === 0 ? (
          <Typography>{t("noExtrasChoosed")}</Typography>
        ) : (
          vehicleExtras
            ?.filter((fee) => fee.quantity > 0)
            ?.map((fee, idx) => (
              <Typography key={idx}>
                {fee.extraName === "fullInsurance"
                  ? t("fullInsurance")
                  : fee.extraName === "babySeat"
                  ? t("babySeat")
                  : fee.extraName === "babySeatIsofix"
                  ? t("babySeatIsofix")
                  : fee.extraName === "boosterSeat"
                  ? t("boosterSeat")
                  : fee.extraName === "additionalDriver"
                  ? t("additionalDriver")
                  : fee.extraName === "youngDriver"
                  ? t("youngDriver")
                  : fee.extraName === "airportDeliveryExtra"
                  ? t("airportDeliveryExtra")
                  : fee.extraName === "outOfFunchalDelivery"
                  ? t("outOfFunchalDelivery")
                  : null}
                {" -> "}
                {fee.totalValue}€
              </Typography>
            ))
        )}
        <Typography>
          <b>{t("instructionsTitle")}</b>
          <p>
            {pickUpDesk === 41
              ? t("funchalInstructions")
              : pickUpDesk === 42
              ? t("airportInstructions")
              : t("hotelInstructions")}
          </p>
        </Typography>

        <Typography>
          <b>{t("location")}</b>
        </Typography>
        {pickUpDesk === 42 ? (
          <p>
            <a
              href="https://www.google.com/maps?q=Why+Not+Car+Rental+Santa+Cruz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://maps.googleapis.com/maps/api/staticmap?center=32.69399,-16.78285&zoom=15&size=600x300&markers=color:red%7Clabel:W%7C32.69399,-16.78285&key=AIzaSyDFZyTjVSFQqi3JU9_OnfzDudZFVk3jYX0"
                alt="Mapa da localização"
                onLoad={() => setMapLoaded(true)}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  border: "1px solid #ccc",
                }}
              />
            </a>
          </p>
        ) : pickUpDesk === 41 ? (
          <p>
            <a
              href="https://www.google.com/maps?q=Why+Not+Car+Rental+Funchal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://maps.googleapis.com/maps/api/staticmap?center=32.64840087853654,-16.911741331316563&zoom=15&size=600x300&markers=color:red%7Clabel:W%7C32.64840087853654,-16.911741331316563&key=AIzaSyDFZyTjVSFQqi3JU9_OnfzDudZFVk3jYX0"
                alt="Mapa da localização"
                onLoad={() => setMapLoaded(true)}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  border: "1px solid #ccc",
                }}
              />
            </a>
          </p>
        ) : null}

        <Typography>
          <b>{t("furtherQuestions")} </b>
        </Typography>
        <Typography href={"mailto:front.office@whynotcarrental.com"}>
          <b>{t("email")}:</b> reservations@whynotcarrental.com
        </Typography>
        <Typography target="_blank" href="tel:00351291213100">
          <b>{t("phone")}:</b> +351 291213100
        </Typography>
        <Typography
          target="_blank"
          href="https://api.whatsapp.com/send/?phone=351967762981&text&type=phone_number&app_absent=0"
        >
          <b>WhatsApp:</b> +351 967762981
        </Typography>
        <Typography>{t("bestRegards")}</Typography>
        <Typography>WhyNot Car Rental</Typography>
        <img
          src={emailSignature}
          alt="WhyNot Car Rental Logo"
          style={{ width: "100%", maxHeight: "300px", display: "block" }}
        />
      </>
    </div>
  );
};

Confirmation.propTypes = {
  vehicleChoosedDetails: PropTypes.any,
  reservationDetails: PropTypes.any,
  checkInData: PropTypes.any,
  clientDetails: PropTypes.any,
  vehicleExtras: PropTypes.any,
  totalRentalValue: PropTypes.any,
  pickUpDesk: PropTypes.number,
  dropOffDesk: PropTypes.number,
  totalDays: PropTypes.number,
  paymentType: PropTypes.string,
  fullTotalValue: PropTypes.any,
};

export default Confirmation;
